module.exports = __webpack_public_path__ + "img/chevron-left.e790dc4f.svg";